import { WMSLegend, ComponentLegend, OverlayerLegend } from "src/types";

export function isComponentLegend(legend: OverlayerLegend): legend is ComponentLegend {
  return legend.legendType === "component";
}

export function isWMSLegend(legend: OverlayerLegend): legend is WMSLegend {
  return legend.legendType === "wms";
}
